import { stringify } from 'query-string';
import React, { FC, useLayoutEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import { ProjectId, TaskIdV2 } from 'api/models';
import { transformer } from 'components/organisms/task-drawer';

export const TaskPaneHashRewrite: FC = ({ children }) => {
  const { replace } = useHistory();
  const { search, hash } = useLocation();

  useLayoutEffect(() => {
    const groups = (hash ?? '').match(
      /.*task(?<project_id>\d+)!(?<task_id>\d+).*/,
    )?.groups;
    const project_id = parseInt(groups?.project_id ?? '', 10);
    const task_id = parseInt(groups?.task_id ?? '', 10);
    const open_approvals_tab = search.includes('tab=approvals');

    if (!Number.isNaN(project_id) && !Number.isNaN(task_id)) {
      replace({
        search,
        hash: `${hash.replace(
          `task${project_id}!${task_id}`,
          stringify(
            transformer.to(['show', ProjectId(project_id), TaskIdV2(task_id)]),
          ),
        )}${open_approvals_tab ? '&task_drawer_tab=approvals' : ''}`,
      });
    }
  }, [hash, search, replace]);

  return <>{children}</>;
};
